<template>
  <div class="card">
    <h5 class="card-header">{{title}}</h5>
    <div class="card-body">
      <span class="display-3">{{$n(value)}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["title", "value"]
  }
</script>

<style lang="scss" scoped>
.card-body {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Visuals/BigNumber.vue